import Cookies from "js-cookie";

const tokenName = process.env.NEXT_PUBLIC_NAME_COOKIES as string;
const entityName = process.env.NEXT_PUBLIC_NAME_ENTITY_COOKIES as string;
const userTokenName = process.env.NEXT_PUBLIC_NAME_USER_COOKIES as string;
const passwordStatusName = 'password_status';
const customerIdName = 'customer_id';

const getToken = (): string | undefined => {
  return Cookies.get(tokenName);
};

const getEntity = (): number[] => {
  try {
    const entityStr = Cookies.get(entityName);
    return entityStr ? JSON.parse(entityStr) : [];
  } catch (error) {
    console.error("Error parsing entity:", error);
    return [];
  }
};

const setEntity = (entities: number[]): void => {
  Cookies.set(entityName, JSON.stringify(entities), {
    secure: true,
    sameSite: "strict",
  });
};

const removeEntity = (): void => {
  Cookies.remove(entityName);
};

const setToken = (token: string): void => {
  Cookies.set(tokenName, token, { secure: true, sameSite: "strict" });
};

const removeToken = (): void => {
  Cookies.remove(tokenName);
};

const getUser = (): string | undefined => {
  return Cookies.get(userTokenName);
};

const setUser = (user: string): void => {
  Cookies.set(userTokenName, user, { secure: true, sameSite: "strict" });
};

const removeUser = (): void => {
  Cookies.remove(userTokenName);
};

const getPasswordStatus = (): string | undefined => {
  return Cookies.get(passwordStatusName);
};

const setPasswordStatus = (status: string): void => {
  Cookies.set(passwordStatusName, status, { secure: true, sameSite: "strict" });
};

const removePasswordStatus = (): void => {
  Cookies.remove(passwordStatusName);
};

const needsPasswordChange = (): boolean => {
  return getPasswordStatus() === 'd';
};

const getCustomerId = (): number | null => {
  try {
    const customerIdStr = Cookies.get(customerIdName);
    return customerIdStr ? JSON.parse(customerIdStr) : null;
  } catch (error) {
    console.error("Error parsing customer_id:", error);
    return null;
  }
};

const setCustomerId = (customerId: number | null): void => {
  if (customerId === null) {
    Cookies.remove(customerIdName);
  } else {
    Cookies.set(customerIdName, JSON.stringify(customerId), {
      secure: true,
      sameSite: "strict",
    });
  }
};

const removeCustomerId = (): void => {
  Cookies.remove(customerIdName);
};

export const getAllowedEntities = (): number[] => {
  const allowedEntitiesStr = process.env.NEXT_PUBLIC_ALLOWED_ENTITIES;
  if (!allowedEntitiesStr) return [];

  try {
    return allowedEntitiesStr.split(',').map(Number).filter(n => !isNaN(n));
  } catch (error) {
    console.error('Error parsing allowed entities:', error);
    return [];
  }
};

export const isAllowedEntity = (entityFromCookie: number[]): boolean => {
  const allowedEntities = getAllowedEntities();
  return Array.isArray(entityFromCookie) &&
    entityFromCookie.some(entity => allowedEntities.includes(entity));
};

export {
  getEntity,
  getToken,
  getUser,
  removeEntity,
  removeToken,
  removeUser,
  setEntity,
  setToken,
  setUser,
  getPasswordStatus,
  setPasswordStatus,
  removePasswordStatus,
  needsPasswordChange,
  getCustomerId,
  setCustomerId,
  removeCustomerId,
};
